import { useDebugValue, useState } from 'react';
import FileSaver from 'file-saver';

import ajaxClient from '../../../../utils/ajaxClient';
import { interceptErrorMessage } from '../../../../shared/helpers/apiErrorsInterceptor';

const useExportQuestionnaire = () => {
  useDebugValue('useExportQuestionnaire');

  const [isExporting, setIsExporting] = useState(false);

  const exportQuestionnaire = (id, data, onSuccess, onError) => {
    setIsExporting(true);
    const url = `Forms/${id}/Export`;

    return ajaxClient
      .downloadRequest(url, null, `"${data}"`, false)
      .then((response) => {
        const disposition = response.headers['content-disposition'];
        const fileName = decodeURI(disposition.match(/filename\*=UTF-8''(.*)/)[1]);
        FileSaver.saveAs(response.data, fileName);
        setIsExporting(false);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((exception) => {
        if (exception) {
          if (onError) {
            onError(interceptErrorMessage(exception));
          }

          setIsExporting(false);
        }
      });
  };

  return {
    exportQuestionnaire, isExporting,
  };
};

export default useExportQuestionnaire;
